import React from 'react';
import { styled } from '@material-ui/core';
import { FilledButton, OutlinedButton, Dropdown } from '@ds/react-components';
import {
  Paper,
  PaperBody,
  PaperHeader,
  PaperHeaderText,
} from '../../../Cancellation.styled';

export { Paper, PaperHeader, PaperHeaderText };

export const PaperBodyOverload = styled(({ loading, ...other }) => (
  <PaperBody {...other} />
))(({ loading }) => ({
  padding: '2px 32px 16px 32px',
  opacity: loading ? 0.5 : 1,
  pointerEvents: loading ? 'none' : 'initial',
}));

export const ActionButtonContainer = styled('div')({
  display: 'flex',
  marginTop: '18px',
});

export const BackButton = styled(OutlinedButton)({
  marginLeft: '16px',
});

export const ConfirmSubmissionButton = styled(FilledButton)({
  fontWeight: 'bold',
});

export const InputWrapper = styled('div')({
  margin: '16px 0',
});

export const CancelReasonDropdown = styled(Dropdown)({
  maxWidth: '390px',
});

export const LoadingConfirmTextContainer = styled('div')({
  marginLeft: '1px',
});
